var map = require('./map');
var prop = require('../function/prop');

    /**
     * Extract a list of property values.
     */
    function pluck(obj, propName){
        return map(obj, prop(propName));
    }

    module.exports = pluck;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/pluck.js
// module id = 1511
// module chunks = 0